export default __webpack_public_path__ + "static/media/combank_logos.c82bcd28.jpg";